<ngx-loading [show]="loading"></ngx-loading>

<div *ngIf="!isEditionMode">

  <div class="modal-header">
    <h4 class="d-block text-center w-100" id="modal-basic-title">
      Task: {{task.name}}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="row main-data">

      <div class="col-md-5 offset-md-1 border-left">

        <div class="due-date d-flex flex-row align-items-center mb-2">
          <i class="fa fa-calendar pr-3" [ngClass]="{'text-danger': isTaskExpired(task)}"></i>
          <span [ngClass]="{'text-danger': isTaskExpired(task)}">
            <strong>{{isTaskExpired(task) ? 'Expired' : 'Due date:'}}</strong>
            {{task.due_date | date: 'MM/dd/yyyy':'utc' || 'N/A'}}
          </span>
        </div>

        <div class="responsible d-flex flex-row align-items-center mb-2">
            <i class="fa fa-user-circle-o pr-3"></i>
            <span>
              <strong>Responsible:</strong> {{task.responsible.name}}
              <br>({{task.responsible.organization_name}})
            </span>
        </div>

      </div>

      <div class="col-md-5 border-left">

        <div class="status mb-2">
          <span class="badge badge-pill" [ngClass]="{
            'badge-warning': task.status === 'PENDING' && !isTaskExpired(task),
            'badge-danger': task.status === 'PENDING' && isTaskExpired(task),
            'badge-success': task.status === 'COMPLETED',
            'badge-success': task.status === 'APPROVED',
            'badge-danger': task.status === 'REJECTED'
          }">
            <i class="fa fa-warning" *ngIf="task.status === 'PENDING' && isTaskExpired(task)"></i>
            {{task.status}}
          </span>
        </div>

        <div class="task-type mb-2">
          <strong>
            Task type:
          </strong>
          {{task.task_type.name}}
        </div>

        <div class="no-relations mb-2" *ngIf="!task.affected_task_instance_id && !task.depends_on_task_instance_id">
          <small>
            This task does not approve or depends upon other tasks.
          </small>
        </div>

        <div class="approves-task related-task d-flex flex-row mb-2" *ngIf="task.affected_task_instance_id">
          <strong>
            Approves:
          </strong>
          <div class="task-box border" (click)="goToTask(task.affected_task_instance_id, task)"
            [matTooltip]="'Go to task: '.concat(getTask(task.affected_task_instance_id)?.name)"
            [matTooltipDisabled]="!getTask(task.affected_task_instance_id)?.name">
            <i class="fa fa-caret-right"></i>
            {{getTask(task.affected_task_instance_id)?.name || 'N/A'}}
          </div>
        </div>

        <div class="depends-on related-task d-flex flex-row mb-2" *ngIf="task.depends_on_task_instance_id && !task.affected_task_instance_id">
          <strong>
            Depends on:
          </strong>
          <div class="task-box border" (click)="goToTask(task.depends_on_task_instance_id)"
            [matTooltip]="'Go to task: '.concat(getTask(task.depends_on_task_instance_id)?.name)"
            [matTooltipDisabled]="!getTask(task.depends_on_task_instance_id)?.name">
            <i class="fa fa-caret-right"></i>
            {{getTask(task.depends_on_task_instance_id)?.name || 'N/A'}}
          </div>
        </div>


      </div>

    </div>

    <div class="row mt-4" *ngIf="approvalTask">
      <div class="col-md-12">

        <div class="approval-info alert alert-info">
          <i class="fa fa-info"></i>
          You are in approval mode. Please review that this task's requirements have been fulfilled and use the "Approve" or "Reject" buttons.
        </div>
        <div class="approval-buttons text-center">
          <button type="button" class="btn btn-success" (click)="approveTask()">Approve</button>
          <button type="button" class="btn btn-danger" (click)="rejectTask()">Reject</button>
        </div>

      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">

        <ngx-title-divider title="Description" [bold]="true"></ngx-title-divider>
        <div class="description bg-light p-3 border rounded">
          <span [innerHTML]="task.description | markdown"></span>
        </div>

      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">

        <ngx-title-divider title="Attachments - for reference" [bold]="true"></ngx-title-divider>
        <span>This task has no attachments.</span>

      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <ngx-title-divider title="{{task.completed_by ? 'Task requirements fulfilled' : 'Pending action'}}" [bold]="true"></ngx-title-divider>

        <div class="action-details" *ngIf="!task.completed_by">
          <i class="fa fa-lock" *ngIf="!task.active"></i>
          {{getCtaText()}}
        </div>

        <div class="action-cta d-flex flex-row align-items-end mt-4" *ngIf="!task.completed_by && task.active">
          <input type="file" class="d-none" id="file-input" (change)="completeTaskWithFile($event)">

          <mat-form-field id="entity-value" class="m-0 d-inline-block w-auto"
            *ngIf="task.task_type.interaction_type === 'submit' && !task.completed_by"
            style="margin: 0 !important; width: 100% !important;"
            [(ngModel)]="entityValue"
            ngDefaultControl>
            <textarea placeholder="Type here..."
                rows="3"
                name="entity-value"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="999"
                matInput></textarea>
            <!-- <input placeholder="Type here..." 
                maxlength="35" 
                [disabled]="!task.active" 
                autocomplete="off"
                name="entity-value"
                matInput/> -->
          </mat-form-field>

          <div class="btn-wrapper p-0 m-0" style="max-height: 100px;">
            <button type="button" class="btn btn-success" 
              *ngIf="!task.completed_by && task.task_type.interaction_type"
              [disabled]="!task.active"
              (click)="handleCtaButtonClick($event, task.task_type.interaction_type === 'simple')"
              style="white-space: nowrap; height: 100%;">
              {{task.task_type.action_cta | uppercase}}
            </button>
          </div>
        </div>

        <div class="entity-value alert mt-4" *ngIf="task.completed_by"
          [ngClass]="{
            'alert-danger': task.task_type.interaction_type === 'approve' && !task.entity.value,
            'alert-success': !(task.task_type.interaction_type === 'approve' && !task.entity.value)
          }">
          <i class="fa fa-check"></i> This task has been completed by {{task.completed_by.name}} ({{task.completed_by.organization_name}}) at {{(task.completed_at | date:'MM/dd/yyyy HH:mm':getUserTimezone()) || 'N/A'}}
          <br><br>

          <div class="confirmation-value" *ngIf="task.entity?.value !== null && task.task_type.interaction_type === 'approve'">
            <strong>{{task.entity.value === true ? 'Approved.' : 'Rejected.'}}</strong>
            <span *ngIf="task.entity.value === false">Reason: {{task.entity?.rejection_reason || 'N/A'}}</span>
          </div>

          <div class="confirmation-value" *ngIf="task.entity?.value && task.task_type.interaction_type === 'simple'">
            <strong>Action:</strong>
            <span>{{task.entity.value ? 'Marked as completed' : 'Marked as not completed'}}</span>
          </div>

          <div class="submitted-data" *ngIf="task.task_type.entity_data_value_type === 'str' && task.entity?.value && !task.entity?.file">
            <strong>Provided data:</strong>
            <pre>{{task.entity.value}}</pre>
          </div>

          <div class="submitted-file" *ngIf="task.entity?.file?.link && task.entity?.value">
            <strong>Provided file:</strong>
            <a ngxFilesPreview  [fileName]="task.entity.file.name" [fileId]="task.entity?.value" class="text-underline">
              <!-- <i class="fa fa-file-excel-o mr-2"></i> -->
              <!-- <i class="fa fa-file-pdf-o mr-2"></i> -->
              <!-- <i class="fa fa-file-word-o mr-2"></i> -->
              <!-- <i class="fa fa-file-image-o mr-2"></i> -->
              <!-- <i class="fa fa-file-video-o mr-2"></i> -->
              <!-- <i class="fa fa-file-audio-o mr-2"></i> -->
              <!-- <i class="fa {{getIconClass}} mr-2"></i> -->
              <i class="fa fa-file mr-2"></i>
              {{task.entity.file.name}}
            </a>
          </div>
          
        </div>
      </div>
    </div>

    <div class="row mt-4">

      <div class="col-md-12">
        <ngx-po-notes-form
          [allowEdit]="true"
          [unreadMessages]="0"
          [poID]="task.instance_id"
          [customerID]="po?.customer_id"
          [supplierID]="po?.supplier_id"
          [notes]="[]"
          [isScrollingEnabled]="true"
        ></ngx-po-notes-form>
      <!-- <ngx-po-notes-form
          [allowEdit]="true"
          [unreadMessages]="purchaseOrder?.unread_messages"
          [poID]="purchaseOrder?.id"
          [customerID]="purchaseOrder?.customer_id"
          [supplierID]="purchaseOrder?.supplier_id"
          [notes]="purchaseOrder?.notes"
          (notesChangedEvent)="handleNotesChange($event)"
          [isScrollingEnabled]="true"
        ></ngx-po-notes-form> -->
      </div>

    </div>

    <div class="row mt-4 bg-light pt-4">

      <div class="col-md-12 p-0">
        <!-- <div class="container-fluid py-4" *ngIf="!!actions && !onlyEDI && (!isRCDSS || companyType === 'customer')"> -->
        <!-- Activity log -->
        <ngx-resource-actions [actions]="[]"></ngx-resource-actions>
        <!-- <ngx-resource-actions [actions]="actions"></ngx-resource-actions> -->
      </div>

    </div>

  </div>



  <div class="modal-footer">
    <button type="button" class="btn btn-primary" *ngIf="role === 'Lasgro Admin' && !isEditionMode" (click)="edit()">
            Edit
    </button>
    <button type="button" class="btn btn-success" *ngIf="role === 'Lasgro Admin' && isEditionMode" (click)="save()">
            Save
    </button>
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
  </div>
</div>

